import { Navigate } from "react-router-dom";

const AuthGuard = ({ children }) => {
  const token = localStorage.getItem("token");

  const isAuthenticated = Boolean(
    token && token !== "undefined" && token !== "null"
  );

  // If already logged in → go to dashboard
  if (isAuthenticated) {
    return <Navigate to="/user" replace />;
  }

  return children;
};

export default AuthGuard;